<template>
    <div>
        <el-drawer
            :visible.sync="showModal"
            append-to-body
            direction="btt"
            @closed="resetForm"
            size="95%"
            :style="{
                maxWidth: '500px',
                left: '50%',
                transform: 'translateX(-50%)',
            }"
        >
            <template slot="title" class="mb-0">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag type="success">
                        <i class="el-icon-plus"></i>
                    </el-tag>
                    <h5 class="font-weight-semibold mb-0">Novo Popup</h5>
                </div>
            </template>

            <div class="px-4 pb-3 d-flex flex-grow-1 flex-column justify-content-between">
                <el-form
                    :model="payload"
                    ref="popupForm"
                    label-position="top"
                    status-icon
                >
                    <el-row :gutter="12">
                        <!-- Imagem -->
                        <el-col>
                            <el-form-item
                                prop="imagem"
                                :rules="[
                                    { required: true, message: 'A imagem é obrigatória' },
                                ]"
                            >
                                <label>Imagem</label>
                                <FormDragAndDropUpload
                                    v-model="payload.imagem"
                                    accept="image/*"
                                    :max-size="1"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Titulo -->
                        <el-col>
                            <el-form-item
                                prop="title"
                                :rules="[
                                    { required: true, message: 'O título é obrigatório' },
                                    { validator: validateMin(3, 'O título deve possuir no mínimo 3 caracteres'), trigger: 'blur' },
                                ]"
                            >
                                <label>Título</label>
                                <el-input
                                    v-model="payload.title"
                                    placeholder="Digite o título"
                                    :disabled="isSubmiting"
                                    clearable
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Subtitulo -->
                        <el-col>
                            <el-form-item prop="subTitle">
                                <label>Subtítulo</label>
                                <el-input
                                    v-model="payload.subTitle"
                                    placeholder="Digite o subtítulo"
                                    :disabled="isSubmiting"
                                    clearable
                                />
                            </el-form-item>
                        </el-col>

                        <el-col>
                            <el-divider class="my-1"></el-divider>
                        </el-col>

                        <!-- Botao -->
                        <el-col>
                            <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-button type="primary" plain circle :style="{ pointerEvents: 'none' }">
                                        <i class="el-icon-mouse"></i>
                                    </el-button>
                                    <h6 class="mb-0 font-weight-bold">Possui botão?</h6>
                                </div>

                                <el-form-item class="mb-0">
                                    <el-switch
                                        v-model="payload.have_button"
                                        active-text="Sim"
                                        inactive-text="Não"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>

                        <template v-if="payload.have_button">
                            <el-col>
                                <el-form-item
                                    prop="button_text"
                                    :rules="[
                                        { required: true, message: 'O texto do botão é obrigatório' },
                                    ]"
                                >
                                    <label>Texto do botão</label>
                                    <el-input
                                        v-model="payload.button_text"
                                        placeholder="Ex: Saiba mais"
                                        :disabled="isSubmiting"
                                        clearable
                                    />
                                </el-form-item>
                            </el-col>

                            <el-col>
                                <el-form-item
                                    prop="action_button_link"
                                    :rules="[
                                        { required: true, message: 'O link do botão é obrigatório' },
                                    ]"
                                >
                                    <label>Link do botão</label>
                                    <el-input
                                        v-model="payload.action_button_link"
                                        placeholder="https://..."
                                        :disabled="isSubmiting"
                                        clearable
                                    />
                                </el-form-item>
                            </el-col>
                        </template>

                        <!-- Sempre ativo -->
                        <el-col>
                            <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-button :type="payload.always_active ? 'success': 'info'" plain circle :style="{ pointerEvents: 'none' }">
                                        <i v-if="payload.always_active" class="el-icon-unlock"></i>
                                        <i v-else class="el-icon-lock"></i>
                                    </el-button>
                                    <h6 class="mb-0 font-weight-bold">Sempre ativo</h6>
                                </div>

                                <el-form-item class="mb-0">
                                    <el-switch
                                        v-model="payload.always_active"
                                        active-text="Sim"
                                        inactive-text="Não"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>

                <!-- Actions -->
                <el-row class="mt-3">
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-button
                                plain
                                type="danger"
                                :disabled="isSubmiting"
                                @click="() => {
                                    toggleModal();
                                    resetForm();
                                }"
                            >
                                Cancelar
                            </el-button>

                            <el-button
                                type="primary"
                                :disabled="isSubmiting"
                                @click="onSubmit"
                            >
                                Salvar
                                <i v-if="isSubmiting" class="el-icon-loading"></i>
                                <i v-else class="el-icon-right"></i>
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Row,
        Col,
        Button,
        Input,
        Notification,
        Drawer,
        Switch,
        Divider,
        Tag,
    } from "element-ui";

    import { FormDragAndDropUpload } from "@/components/_micro/Form/_index";

    // Utils
    import { validateMin } from "@/schemas/generalSchema";

    // Api
    import { PopupApi } from "@/api/PopupApi";

    const popupApi = new PopupApi();

    const emptyPayload = () => ({
        imagem: null,
        title: null,
        subTitle: null,
        have_button: false,
        always_active: false,
        action_button_link: null,
        button_text: null,
    });

    export default {
        data() {
            return {
                payload: emptyPayload(),
                showModal: false,
                isSubmiting: false,
            }
        },
        methods: {
            onSubmit() {
                this.$refs.popupForm.validate( async (valid) => {
                    if (!valid) {
                        this.$message({
                            message: 'Atenção, há campo(s) obrigatório(s) não preenchido(s)',
                            type: 'warning',
                            showClose: true,
                        });

                        return false
                    }

                    // Sem botão, os campos do botão não são enviados
                    const data = { ...this.payload };
                    if (!data.have_button) {
                        data.button_text = null;
                        data.action_button_link = null;
                    }

                    // FormData: necessário para enviar o arquivo da imagem
                    const formData = new FormData();
                    formData.append('title', data.title ?? '');
                    formData.append('subTitle', data.subTitle ?? '');
                    formData.append('have_button', data.have_button ? 1 : 0);
                    formData.append('always_active', data.always_active ? 1 : 0);
                    formData.append('button_text', data.button_text ?? '');
                    formData.append('action_button_link', data.action_button_link ?? '');
                    formData.append('imagem', data.imagem);

                    this.isSubmiting = true;

                    try {
                        await popupApi.store(formData);

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Popup criado com sucesso!'
                        });

                        this.toggleModal();
                        this.resetForm();
                        this.$emit('created');
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }

                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: error?.response?.data?.message ?? 'Não foi possível criar o popup!'
                        });
                    } finally {
                        this.isSubmiting = false;
                    }
                })
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetForm() {
                this.payload = emptyPayload();

                this.$nextTick(() => {
                    this.$refs.popupForm?.clearValidate();
                });
            },
            validateMin,
        },
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Button.name]: Button,
            [Input.name]: Input,
            [Drawer.name]: Drawer,
            [Switch.name]: Switch,
            [Divider.name]: Divider,
            [Tag.name]: Tag,
            FormDragAndDropUpload,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/popup/PopupCreateModal.vue